export default __webpack_public_path__ + "553f04774dadcbd21348228ba6df3c36.png";